export enum Chain {
  ARBITRUM,
  ETHEREUM,
  HEDERA,
  STELLAR,
}
